// src/components/DebitsInfoSection.tsx
import React from 'react';

export const DebitsInfoSection: React.FC = () => {
  return (
    <section id="debits-info" className="bg-blue-50 border-l-4 border-blue-400 p-4 mb-4">
      <div className="flex">
        <div className="ml-3">
          <h3 className="text-sm font-medium text-blue-800">
            O que são considerados débitos quando o cliente quer retornar?
          </h3>
          <div className="mt-2 text-sm text-blue-700">
            <p className="mb-2">
              São considerados débitos do locatário os seguintes itens:
            </p>
            <ul className="list-disc list-inside space-y-1">
              <li>Multas de trânsito durante o período de locação</li>
              <li>Avarias do veículo identificadas na devolução</li>
              <li>Manutenções em atraso não realizadas pelo locatário</li>
              <li>Multas por excesso de quilometragem</li>
              <li>Violações do cronograma de manutenção do veículo</li>
              <li>Outros custos relacionados ao uso inadequado do veículo</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};